var exports = {
  "k": "xaf9ae18d--9e0d31--container",
  "b": "xaf9ae18d--9e0d31--container--moved",
};

module.exports = exports;
